import React, { useEffect, useState } from 'react';
import { CarIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { advisor } from '../data/catalog';
import { track } from '../config/site';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Barra de acción fija en móvil: llamar, WhatsApp y cotizar.
 * Aparece al pasar el hero para no tapar la portada.
 */
export function MobileActionBar() {
  const {
    t
  } = useLanguage();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-canvas/95 backdrop-blur-sm transition-[transform,opacity] duration-500 ease-[var(--ease-lux)] lg:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-256" data-mp="vbqhn8f0gx0">
      <div className="grid grid-cols-3 items-stretch gap-px bg-line" data-id="element-257" data-mp="1eikold9clfft">
        <a href={advisor.phoneHref} onClick={() => track('Contact', {
        method: 'phone',
        location: 'mobile_bar'
      })} className="flex flex-col items-center justify-center gap-1 bg-canvas py-3 text-[11px] uppercase tracking-[0.16em] text-white" data-id="element-258" data-mp="1ahr1gm3qc4nz">
          <PhoneIcon className="h-[18px] w-[18px] text-guards" aria-hidden="true" data-id="element-259" data-mp="vtczsei1um90" />
          {t.mobileBar.call}
        </a>
        <a href={advisor.whatsappHref} target="_blank" rel="noreferrer" onClick={() => track('Contact', {
        method: 'whatsapp',
        location: 'mobile_bar'
      })} className="flex flex-col items-center justify-center gap-1 bg-canvas py-3 text-[11px] uppercase tracking-[0.16em] text-white" data-id="element-260" data-mp="qu0cxtr6hf6f">
          <MessageCircleIcon className="h-[18px] w-[18px] text-gentian-bright" aria-hidden="true" data-id="element-261" data-mp="2h5xxli8ocjhj" />
          {t.mobileBar.whatsapp}
        </a>
        <a href="#contacto" className="btn-glint btn-glint-sheen flex flex-col items-center justify-center gap-1 bg-guards py-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-white" data-id="element-262" data-mp="2vbg2jzmcww9l">
          <CarIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-263" data-mp="2mde33oi9ubof" />
          {t.mobileBar.quote}
        </a>
      </div>
    </div>;
}